import ChartInteractions from "./lib/chart";
import Sort from "./lib/Sort";
import Listing from "./listing";
import Filter from "./filter"
import {isEmpty, includes, merge} from "lodash";
import Validator from "./lib/Validator";
import CalculatorOptions from "./lib/CalculatorOptions";
import ChartBox from "./chart";
import {postRequest} from "./lib/Api";
import CalculatorLabels from "./lib/CalculatorLabels";

const Calculator = {
  get store() {
    return this.$store.configurator
  },

  fetchUrl: '/c/list',

  errors: [],
  validated: false,
  options: CalculatorOptions,
  labels: CalculatorLabels,

  setCalculationStyle(value) {
    if (this.store.calculationStyle !== value) {
      this.store.calculationStyle = value
      ChartInteractions.updateChartData(false)
    }
  },

  fetchData() {
    this.resetListingAndChart()

    isEmpty(this.options.aboveSeaLevel) && (this.options.aboveSeaLevel = "0")
    isEmpty(this.options.oil) && (this.options.oil = "ISO VG 46")
    isEmpty(this.options.pumpType) && (this.options.pumpType = "0.7")

    // merge calculation style into options (stored inside the store)
    Object.assign(this.options, {calculationStyle: this.store.calculationStyle})

    this.validate()
    this.validated = true

    this.store.displayStyle = this.options.calculationStyle
    ChartInteractions.updateChartData()

    if (isEmpty(this.errors)) {

      this.toggleLoading()
      this.addCalulationMethodToOptions()

      postRequest(this.fetchUrl, JSON.stringify(this.options)).then(data => {
        this.store.originalListingData = this.parseSoundLevelToFloat(this.normalizeResults(data))

        Filter.run()

        Listing.reOrderListingData(
          Sort.store[0].key,
          !isEmpty(this.store.listingDataChecked)
        )

        Listing.calculationStyle = this.store.calculationStyle

        this.options.specificCoolingCapacity = this.normalizeResults(data, 'meta').specificCoolingCapacity
        this.validated = false
        this.toggleLoading()
      })
    }
  },

  normalizeResults(results, type = 'products') {
    return type === 'products'
      ? Object.values(JSON.parse(results)[type])
      : JSON.parse(results)[type]
  },

  parseSoundLevelToFloat(results) {
    return results.map(item => {
      item.metric_noise_level = parseFloat(item.metric_noise_level)
      item.imperial_noise_level = parseFloat(item.imperial_noise_level)

      return item
    })
  },

  hasError(fieldId) {
    return includes(this.errors, fieldId)
  },

  validate() {
    this.errors = Validator.run()
  },

  inputValidate() {
    this.validated && this.validate()
  },

  toggleLoading() {
    this.store.isLoading = !this.store.isLoading
  },

  resetListingAndChart() {
    Listing.isMinOneItemSelected() && Listing.uncheckAllItems()

    this.store.listingData = []
    ChartInteractions.updateChartData(false)
  },

  init() {
    Spruce.watch('configurator.calculationMethod', value => {

      if (value === 'pumpData') {
        this.options.coolingPower = ''
        this.options.tankCapacity = ''
        this.options.startingTemperature = ''
        this.options.endTemperature = ''
        this.options.heatingTime = ''
      }

      if (value === 'alreadyKnown') {
        this.options.oilPressure = ''
        this.options.pumpType = ''
        this.options.tankCapacity = ''
        this.options.startingTemperature = ''
        this.options.endTemperature = ''
        this.options.heatingTime = ''
      }

      if (value === 'heatingUpTime') {
        this.options.coolingPower = ''
        this.options.oilPressure = ''
        this.options.pumpType = ''
      }
    })
  },

  addCalulationMethodToOptions() {
    this.options = merge(this.options, {calculationMethod: this.store.calculationMethod})
  },

  fetchFromPumpData() {
    this.store.calculationMethod = 'pumpData'

    this.options.oilFlowRate = this.isMetric() ? "100" : "26.42"
    this.options.oilPressure = this.isMetric() ? "200" : "2900"
    this.options.oilInletTemperature = this.isMetric() ? "70" : "158"
    this.options.airInletTemperature = this.isMetric() ? "20" : "68"

    this.options.oil = "ISO VG 46"
    this.options.pumpType = "0.8"
    this.fetchData()
  },

  fetchFromHeatingUpTime() {
    this.store.calculationMethod = 'heatingUpTime'

    this.options.oilFlowRate = this.isMetric() ? "100" : "26.42"
    this.options.oilInletTemperature = this.isMetric() ? "70" : "158"
    this.options.airInletTemperature = this.isMetric() ? "20" : "68"
    this.options.tankCapacity = this.isMetric() ? "1200" : "317"
    this.options.startingTemperature = this.isMetric() ? "20" : "68"
    this.options.endTemperature = this.isMetric() ? "60" : "140"

    this.options.oil = "ISO VG 46"
    this.options.heatingTime = "1.5"
    this.fetchData()
  },

  fetchFromAlreadyKnown() {
    this.store.calculationMethod = 'alreadyKnown'

    this.options.coolingPower = this.isMetric() ?  "15" : "853.04"
    this.options.oilFlowRate = this.isMetric() ? "100" : "26.42"
    this.options.oilInletTemperature = this.isMetric() ? "70" : "158"
    this.options.airInletTemperature = this.isMetric() ? "20" : "68"

    this.options.oil = "ISO VG 46"
    this.fetchData()
  },

  isMetric() {
    return this.store.calculationStyle === 'metric'
  }


}


export default Calculator
